module.exports = {
  qqgdscpjypt: "Global Seafood  Trading  Platform",
  qqgdscpjypt1: "Global Seafood  Trading  Platform",
  qqgdscpjypt2: "(and global high-end aquatic products trading platform)",
  zczh: "Create account",
  yzmdl: "Verification code",
  zhmmdl: "Password",
  sjh: "Mobile phone number",
  yzm: "Verification code",
  yhylsjh: "Bank reserved mobile phone number",
  qsrsjh: "Please enter the mobile phone number",
  qsryzm: "Please enter the password",
  hqyzm: "Get verification",
  qsrmm: "Please enter the password",
  dl: "Sign in",
  dlsb: "Login failure",
  dlgqqcxdl: "Login time out , please login again...",
  zc: "Register",
  zcsb: "Register failure",
  yzmbnwk: "The verification code cannot be empty",
  hqyzmsb: "Failed to obtain the verification code",
  yzmfscg: "The verification code is sent successfully",
  sjhbnwk: "The mobile phone number cannot be empty",
  sjhgscw: "The format of the mobile phone number is incorrect",
  mmbnwk: "The password cannot be empty",
  mmtips:
    "The password must be a combination of 8 to 16 letters, numbers, and characters (cannot be pure numbers).",
  bottomcopyright1:
    "2023 aquatic products trading platform ICP Certificate No. : Beijing ICP  16005856",
  bottomcopyright2: "Beijing public security bureau record No. 11010802026156",
  ztsc: "Topic",
  hello: "Hello",
  qrz: "To approve",
  rzhjkckjyxqy:
    "After authentication, you can view the page of transaction details ",
  qkh: "To create account",
  khhjkzptwcjy:
    "After opening an account, you can complete the transaction on the platform",
  khsbxycxkh: "Account opening failed. You need to open an account again",
  qyz: "To verify",
  dzhyz: "Pending account verification",
  rzqyykhqlxkf:
    "Certified the enterprise has opened an account, please contact customer service",
  zljyz: "The data is under review",
  shz: "Reviewing",
  clz: "Dealing",
  dzqyz: "Electronic signing",
  jnrzbzj: "Arragned the deposit",
  jnrzbzjhkschy:
    "After paying the deposit， please upload the cargo information",
  wyhyxzzycjj: "I have the cargo and I want to organize a auction",
  wyhyxzjmc: "I have the cargo and I want to sell out directly",
  yrz: "Certified",
  hyzx: "Aquatic products information",
  gd: "More",
  qb: "All",
  zq: "Special Zone",
  kssj: "The opening time",
  ksz: "Opening",
  xsz: "Closed",
  xqyzxqldsj: "Monday to Saturday (except for holidays)",
  morning: "9:00 am-11:30 am",
  zwsj: "9:00-16:30",
  jjmc: "Sold out by bidding",
  jjmr: "Buy by bidding",
  wyddxzzycjj: "I have the order and I want to organize a auction",
  gpmc: "Sold out by listing",
  gpmr: "Buy by listing",
  wyddxsgyphy: "I have the orders and I want to purchase the cargo",
  bhtjy: "ncluding 10 transactions",
  bh: "Including ",
  jyy: " transactions",

  jjkp: "Bidding soon",
  jjks: "Coming soon",
  bmz: "Signing up",
  jxz: "Ongoing",
  yjs: "Ended",
  lp: "No sale",
  wbmd: "My sign-up",
  zxsc: "Latest uploading",
  kpsj: "Auction time",
  w: "I",
  wd: "My",
  jg: "Price",
  qpj: "Price",
  dqj: "Price",
  cjj: "Deal price",
  yuan: "Yuan",
  zwxgxx: "No relevant content yet！",

  ryd: "persons read already",
  qxdzcg: "Unliking succeeded",

  bm: "Sign up",
  xzkhjl: "Adding the new cargo record",
  jbxx: "Basic information",
  hymc: "Commodity name",
  qsrhymc: "Please enter commodity name",
  dw: "Unit",
  djtxdw: "Click and fill out the unit",
  tiao: "piece",
  dun: "ton",
  zl: "weight",
  hydz: "Commodity address",
  hyzp: "Commodity photos",
  scp: "Uploading photos",
  zdjz: "（Up to nine photos）",
  bcqtxx: "Additional information",
  bcbtj: "Save and submit",
  cjfdxdydqjg: "Offer must be more than the current price",
  fscgddmfqr: "Send successfully, waiting for the seller's confirmation",
  cjcg: "Offer successfully",
  cjsb: "Offer  unsuccessfully",

  sy: "Home",
  rz: "Authentication",
  grrz: "Personal authentication",
  gsrz: "Company’s authentication",
  sczj: "Uploading files",
  xm: "Name",
  qsrxmxysfzbcyz: "Please enter your name same as ID",
  ztlx: "Company type",
  djxzlx: "Click and select the type",
  jysx: "Business attribute",
  djxzsx: "Click and select the attribute",
  jydz: "Company address",
  djxzdz: "Click and select the address",
  xxdz: "Detailed address",
  qsrxxdz: "Please enter the detailed address",
  jypx: "Major products",

  djxzpx: "Click and select the products",
  gsmc: "Company name",
  qsrgsmcxyyyzzyz: "Please enter the company name same as business license",
  qsrgsmc: "Please enter the company name",
  lxr: "Contact person",
  qsrlxr: "Please enter the contact person",
  qscsfz: "Please upload your photo ID ",
  qscsfzwssfxx: "Please upload your photo ID and complete the ID information",
  qpsbscndyyzz: "Please upload your photo business license",
  djscsfzzm: "Click and upload the front of ID ",
  djscsfzbm: "Click and upload the back of ID ",
  djscyyzz: "Click and upload your photo business license",
  tj: "Submit",
  tjrz: "Submit for certification",
  thcg: "Submit successfully",
  tjsb: "Submit unsuccessfully",
  yqm: "Invitation code ",
  yqmxt: "Invitation Code （optional）",
  qtxyqm: "Please fill out invitation code ",
  sryqmrwkbt:
    "Please enter invitation code ， if none is available, leave it blank",
  qd: "Confirm",
  qx: "Cancel",
  sctpyc: "Upload photos abnormally",
  sfzxmysrxmbyzqcxtr:
    "The name of ID is different from the entered name. Please fill in again",
  yyzzmcysrmcbtzqcxtx:
    "The name of company is different from the business licence. Please fill in again",
  tpsbycqcxsc: "Upload photos abnormally，please check the photos",
  rzsb: "Authenticate unsuccessfully",
  rzyc: "Authenticate abnormally",
  qsryqm: "Please enter the invitation code",

  grzx: "Personal center",
  zhye: "Account balance",
  wdye: "My account balance",
  ljczlc: "To know the recharge process",
  tx: "Withdraw",
  bccg: "Save successfully",
  bcsb: "Save unsuccessfully",
  bcyhcw: "Save user error",
  txtp: "Profile photo",
  bdsjh: "Bind mobile phone number",
  hb: "Change binding",
  dlmm: "Login password",
  qsz: "Install",
  xgmm: "Change password",
  szmm: "Password setting",
  qr: "Confirm",
  djscndtx: "Click and upload your profile photo",
  hbsjh: "Change binding mobile phone number",
  qsrhbsjh: "Please enter the changing mobile phone number",
  dqsjh: "Current mobile phone number",
  ghcg: "Changing successfully",
  xgcg: "Revising successfully",
  szcg: "Setting up successfully",
  uploatips: "The size of the uploaded file cannot exceed 5MB",
  success: "Success",
  fail: "Failure",

  zhmx: "Account details",
  mj: "Seller",
  maij: "Buyer",
  dj: "Blocked",
  djmx: "Blocked account details",
  yjcdj: "Releasing the blocked account",
  zrtxje: "Transfer the withdrawal details",
  pfmx: "Compensation details ",

  rzbzj: "Entry deposit",
  bzjtips:
    "If the seller's client initiates the transaction, the deposit shall not be less than 100,000 yuan.",
  bzjtips1:
    "During the trial operation stage, this regulation is not implemented temporarily",
  zcdz: "Transferred out",
  zrdz: "Transferred in",

  qrcj: "Bid",
  hpmc: "Description of goods",
  zxjg: "The updatest price",
  ykj: "Buy it now price",
  jpcj: "Place bid ",
  cjf: "Bidder",
  dunshu: "Tonnage",
  zdbmds: "Minimum registered tonnage",
  grds: "Tons purchased",
  cjje: "Bid amount",
  qsrndgrds: "Please enter your purchased quantity",
  qsrndcjje: "Please enter your bid amount",

  wddd: "My order",
  hyd: "Origin of goods",
  shd: "Place of receipt",
  djkckmfhy: "Click to view the seller's source of goods ",
  hyzj: "The total amount of goods",
  djtips: "Deposit (freezing performance bond to offset payment for goods",
  fwf: "Service charge",
  wk: "The balance payment",
  ddbh: "Order number",
  copy: "Copy",
  cjsj: "Create date",
  mffk: "Buyer payment",
  ccbg: "The report of goods",
  zskf: "Exclusive customer servic",
  hckf: "Huacai customer servic",
  dfpkf: "To Be Assigned QC",
  lxpk: "Contact QC",
  qfk: "To pay",

  txmfhy: "Fill out the seller‘s goods information",
  ckmfhy: "Review the seller‘s goods information",
  hyxx: "Source of goods information",
  ddxx: "Order information",
  ksrbcne: "Input supplementary content ..",
  bt: "Required",
  xt: "Optional",
  fsgmf: "Sent to the buyer",

  sztx: "Setting up reminders",
  sztxcg: "Setting up reminders successfully",
  qxtxcg: "Cancelling reminders successfully",
  szsb: "Setting up reminders unsuccessfully",
  qxbmcg: "Cancelling sign-in successfully",
  ysz: "Set up",
  jjs: "From end",
  jks: "From start",
  sc: "Duration",
  kdjckkhjl: "Click to view the record of goods",
  bm10sr: "** persons signed up",
  wg10ren: "Watch 10 times",
  jybh: "Deal number",
  jplx: "Auction type",
  jjfd: "Place bid range",
  jjfdjj: "Reduction scope",
  jpsj: "Auction time",
  jpsc: "Auction duration ",
  fz: "Minute",
  yszq: "Delay period",
  jylx: "Deal type",
  scsj: "The time of uploading",
  lxdh: "Tel",
  ppxq: "Auction Details",
  pkbb: "Quality Control Report",
  cjjl: "Records of bid",
  xqms: "Description of demand",
  hyms: "Description of Goods",
  jjr: "Bidder",
  sj: "Time",
  ckgd: "View more",
  zwcjjl: "No bidding record",
  smewmdsj: "Scan a QR Code",
  dqrp: "Current hot auction",
  yhwrzqdgezxrz:
    "User not authenticated, please go to the personal center for authentication ",

  ckkhxx: "View the goods information",
  lsjl: "The history record",
  bmcg: "Signed up successfully",
  dmfqr: "To be confirmed by the buyer",
  mfjj: "The buyer refused",
  mfcswcl: "The buyer didn’t deal with it due to timeout",
  bj: "Edit",
  delete: "Delete",
  qrxgfsgmf: "Confirm modification and send to the buyer",
  qrscgkhxx: "Confirm deleting the viewed goods informaiton？",
  sccg: "Delet successfully",
  ldfs: "Freezing method ",
  jjsz: "Bidding settings ",
  jjrq: "Bidding date",
  djxzjjrq: "Click to select the bidding date",
  jjsj: "Bidding time",
  djxzjjsj: "Click to select the bidding time",
  jjsc: "Bidding duration",
  djxxjjsc: "Click to select the bidding duration",
  srsz: "Put into the number",
  gpsz: "Listed settings",
  jgsz: "Delivery settings",
  yf: "Freight",
  djlybzj: "Freezing performance bond ",
  tjhddsh: "Submit and wait for review",

  bmlb: "Sign-up list",
  dqr: "Pending approval",
  yjj: "Refused",
  yqr: "Confirmed",
  bmbh: "Sign-up number",
  bmsj: "Sign-up time",
  sfjjbm: "Do you refuse to sign up?",

  syrzbzjy: "Remaining deposit (RMB)",
  rzbzjtips1:
    "If the seller initiates a transaction, the deposit must not be less than 100000 yuan",
  zrje: "Transfer-in amount",
  qsrzrje: "Enter the transfer-in amount",
  qbzr: "Transfer-in all",
  yczr: "Transfer-in from here",
  zrcg: "Transfer-in successfully",
  zrsb: "Transfer-in unsuccessfully",

  zcje: "Transfer out amount",
  qsrzcje: "Enter transfer out amount",
  qbzc: "Transfer out all",
  zcz: "Transfer out to",
  zccg1: "Transfer out successfully",
  zcsb1: "Transfer out  unsuccessfully",

  ktzfzh: "Opening an account ",
  grkh: "Individual account",
  qykh: "Company account",
  gtgshkh: "Opening an Individual Business Account",
  khsb: "Opening an account unsuccessfully",
  wdyhk: "My bank card",
  yjhb: "Replacing bank card",
  bdyhk: "Binding the bank card",
  zhlx: "Account type",
  qdjxz: "Please click to select",
  dgzh: "To company",
  dszh: "To private person",
  ckr: "Cardholder",
  qsrckrxm: "Please enter the name of cardholder",
  qsrxm: "Please enter the name",
  yhkh: "Bank card number",
  qsrkh: "Please enter bank card number",
  khh: "Opening bank",
  qsrkhh: "Please enter opening bank",
  zcyh: "Cooperative bank",

  wfbd: "My issue",
  wdjy: "My deal",
  wgzd: "My concern",
  qtgn: "Other function",

  yx: "Email",
  dz: "Address",
  kfzsewm: "Customer service's QR Code",
  qtxzgcyhdwzs:
    "Please fill in the amount of transfer from Zhongguancun Bank to the corporate account",
  skjey: "Account receivable(Yuan)",
  ytjqnxddsh: "Submitted, please wait patiently ",

  yey: "Balance (yuan)",
  txje: "Withdraw amount",
  qsrtxje: "Enter withdraw amount",
  qbtx: "Withdraw all",
  dzyhk: "Incoming bank card",

  jjcj: "Bid",
  ydzdcj: "The bottom price",
  zklyx: "Think again",
  jjcg: "Sold",
  jyts: "Deal notice",
  qrybdyhk: "Confirm that the bank card has been bound ",
  syysyhkxrxzhhk:
    "Use the above bank cards to remit money to the following account",
  zhm: "Account name",
  zhzh: "Account number",
  zhc: "Huacai  Zhang",
  bjyhzgczh: "Beijing Zhongguancun Bank Corporation Limited",
  xzf: "Need to pay",
  wkyf: "Need to pay balance",
  xzzffs: "Select the payment method",
  wdzh: "My account",
  qrzf: "Confirm to pay",
  zhyebzljzr: "Account balance is insufficient, please transfer",
  zfcg: "Pay successfully",
  bmxz: "Instructions for registration",
  dqbdlybzj: "The current bid bond",
  ndzhye: "Your account balance",
  bmjjjbstyxydjbzj:
    "Signing up for bidding means agreeing to freeze the corresponding bid bond ",
  rwhpjth:
    "If the bid is unsuccessful, the frozen bid bond will be released automatically",
  rcgzcdhk:
    "If the auction is successful, the frozen bid bond will be used as a deposit against the payment when you pay the final payment",
  rcgpxjkc:
    " If you fail to perform the contract after successful bidding, the frozen deposit will be deducted",
  zhyebzwfbm: "The account balance is not enough to sign up",
  qzr: "Roll-in",
  qrbm: "Confirm of signing up",

  zd: "Roll-out",
  ye: "Page",

  scxgzj: "Upload the related documents",
  qscyyzz: "Please upload your business license",
  yyqx: "Term of operation",
  qsryyqx: "Please enter term of operation",
  zcdz1: "Registered address",
  qsrzcdz: "Please enter registered address",
  tyshxydm: "Uniform social credit code",
  qsrtyshxydm: "Please enter uniform social credit code",
  qsczzjgdmz: "Upload Certificate of Organization Code",
  djsczzjgdmz: "Click to upload Certificate of Organization Code",
  zzjgdm: "Certificate of Organization Code",
  qsrzzjgdm: "Please enter Certificate of Organization Code",
  zzjgdmzqx: "Certificate of Organization Code valid term",
  qsrzzjgdmzqx: "Please enter Certificate of Organization Code valid term",
  qscswdjz: "Upload Tax registration certificate  ",
  djscswdjz: "Click Tax registration certificate  ",
  swdjzdm: "Tax registration certificate code",
  qscfrsfz: "Pleas upload legal person‘s ID",
  sfzh: "ID",
  qsrsfzh: "Please enter ID",
  sfzyxq: "ID valid date",
  qsryxq: "Please enter the valid date",
  qsclxrsfz: "Please upload the contact person's ID",
  lxrxm: "Contact name",
  lxrsfzh: "Contact ID",
  lxrsjh: "Contact cell phone number",
  qsrlxrsjh: "Please enter the contact person‘s cell phone",
  lxryx: "Email address",
  qsrlxryx: "Please enter the contact email",
  zhmc: "Account name",
  qsrzhmc: "Please enter account ",

  wdfb: "My release",
  tcdl: "Log out",
  smjrxcx: "Scan into Mini apps",
  czgjfbkj: "The operation is more convenient and fast",
  ss: "Search",
  tgsh: "Pass the audit",
  js: "End",
  bohui: "Reject",
  scdd: "Generate",
  xgjg: "Change the price",
  qdgj: "Fixed price change",
  xjhyyy: "Take off the shelf",
  bmhy: "Registered source of goods",
  ckdd: "View the order",
  pkdh: "Quality control telephone",
  bmdjj: "Registered bidding",
  bmdgp: "Registered listing",
  dzdwz: "Liked articles",
  mairu: "Buy",
  maichu: "Sell",
  grxx: "Personal information",
  grsy: "Personal home page",
  quhao: "Area code",
  dfk: "Pending payment",
  djg: "Pending delivery",
  ywc: "Completed",
  qt: "Other",
  dsh: "Pending Review",
  zsz: "On display",
  nhqdl: "Hello, please log in",
  mfzc: "Free registration",

  jyzx: "Trading",
  qgsj: "National",
  qqsj: "Global",
  cczx: "Service",
  gzzx: "Rule",
  lxwm: "Contact us",
  hyzx11: "News",
  sjzx: "Price",
  grzxxx: "Personal",

  szgjjqyjyzx: "Shenzhen International Tuna Trading Center",
  qqgdscpjyzx: "Global Seafood  Trading  Platform",
  djjrjyzx: "Click to Go",
  gjst: "Co-construction ecology",
  hzgyy: "Win-win cooperation",
  gongsijieshao: "Company introduction",
  pingtaijieshao: "Platform introduction",
  dazaoqqzddyyjypt:
    "Build a global online trading center for high-end aquatic products",
  gsjstips111:
    "Initiated by China Water Group Cosco Co., LTD., a subsidiary of China Agricultural Development Group, Huacai Technology (Beijing) Co., Ltd. provides technical and professional support.",
  lliaojiexiangq: "Know the details",
  guankanship: "Watch video",
  xianshangjiaxianxia: "Online + Offline",
  gsjstips222:
    "The company is committed to building a global online trading center for high-end aquatic products, driven by the twin engines of ‘online’ + ‘offline’, connecting remote high-end aquatic products with live auction transactions through a remote digital trading center.",
  sjzgrdbzsrjg: "Upgrade the protein intake structure of the Chinese people",
  gsjstips333:
    "Guided by the concept of big food, guided by the concept of ecological co-construction and win-win cooperation, it promotes the industrial digitization process of high-end aquatic products by means of science and technology, improves the trading and circulation efficiency of global high-end aquatic products, upgrades the protein intake structure of Chinese people, and reconstructs the new digitization ecology of global high-end aquatic products.",
  gaoduanshuichanpzonghefuwupingtai:
    "Comprehensive industrial service platform for high-end aquatic products",
  gsjstips444:
    "Approved by Shenzhen Municipal Government, it is jointly initiated by China Agricultural Development Group and Shenzhen Port Group, with technical support from Beijing Huacai. As Shenzhen national oceangoing fishery base pilot project put into operation. Officially launched on May 12, 2023, the center is a comprehensive industrial service center for high-end aquatic products, focusing on spot trading of high-end aquatic products, integrating standard formulation, new varieties research and development, market information services, technical services, financial services and logistics services.",
  pingtai1: "Covering the world's major tuna trading centers",
  pingtai2:
    "With Shenzhen as the hub, the center links Dalian, Yantai, Zhoushan, Tokyo, Kaohsiung, Bangkok and other important global tuna distribution centers, and sets up delivery warehouse to achieve global delivery; In addition to tuna, the center also covers high-end aquatic products such as codfish, salmon, king crab and lobster.",
  pingtai3:
    "Transaction internationalization, standardization, information and digitization",
  pingtai4:
    "The center undertakes the important task of promoting the innovation and upgrading of the global high-end aquatic product industry, and realizing the internationalization, standardization, informatization and digitalization of aquatic product trading; The Center will gradually build itself into an international high-end aquatic products trading, settlement and pricing center in the Asia-Pacific region by utilizing its strong market operation capability, resource integration capability and preferential policy supporting resources.",
  adv1: "Our advantage",
  adv2: "Cloud trading, global delivery, exclusive resources, Shenzhen prices",
  adv3: "High-end",
  adv4: "High efficiency",
  adv5: "High quality",
  adv7: "High quality",
  adv6:
    "To build a high-end aquatic products trading center, settlement center and pricing center in the Asia-Pacific region",
  cloud1: "Cloud trading",
  cloud2: "Global delivery",
  cloud3: "Exclusive resource",
  cloud4: "Shenzhen price",
  cloud5: "Full traceability",
  cloud6: "AI inspection",
  cloud7: "Data engine",
  cloudIntro1:
    "Comercio en la nube. Compre y venda todo el mundo con un solo clic. Comercio con toques ilimitados",
  cloudIntro2:
    "Cierre global, cierre local en las principales ciudades de distribución del mundo, reduciendo los costos logísticos",
  cloudIntro3:
    "Recursos exclusivos, cuota total de capturas de atún rojo pelágico, canales de comercialización designados",
  cloudIntro4:
    "Shenzhen price lanza los precios reales de las ciudades de los centros mundiales de distribución de atún, ayudando al mercado chino a establecer el centro de precios",
  cloudIntro5:
    "Trazabilidad del producto durante todo el proceso, restauración de la verdadera información del producto, pescado por talla, para lograr un 100% de seguridad alimentaria",
  cloudIntro6:
    "El reconocimiento de imagen AI refuerza la capacidad de control de calidad, reduce el error de inspección tradicional de peces a través de estándares de inspección unificados y mejora la eficiencia de aplicaciones de múltiples escenarios",
  cloudIntro7:
    "Data engine para mejorar la precisión en la toma de decisiones a través de la minería de big data",
  gsdzzzzz:
    "Company address: Room 601A, Building E1, Huateng Century Headquarters Park, Chenjialin Yard 9, Balizhuang, Chaoyang District, Beijing",
  xcxxxx: "Mini apps",
  fwhhhh: "Official Accounts",
  wzdhhh: "Website navigation",
  pzzx: "Delivery",
  login1: "Creating ecological cooperation for mutual benefit",
  login9:
    "Promoting the digitization process of high-end aquatic products through technology",
  login11: "Log in now",
  person1: "Personal home page",
  person2: "Personal information",
  person7: "Account opening procedure",
  qkk: "Go",
  wfbdjy: "My issued deals",
  rxtel: "Hot line",
  kfrxxx: "Hot line",
  gzsjjj: "Working time",
  jqy: "Tuna",
  qtpl: "Other categories",
  cjjjj: "Deal",
  qpppp: "Start shooting",
  plll: "Category",
  pxxx: "Appearance",
  jqyfl: "Classification of tuna",
  zzjx: "Be in progress",
  jssj: "End time",
  ysztx: "Set reminder",
  dpsjgzg: "Large screen",
  cdxx: "Origin",
  ggzbjdx: "Size percentage and size",
  hours: "Hour",
  minus: "Minutes",
  second: "Seconds",
  wxsys: "Scan wechat",
  service1: "What services do we have",
  service2:
    "Provide the customers with the comprehensive professional services that energizes to the persistent increasing of the business.",
  service3: "Financial service",
  service4:
    "Aim to provide comprehensive financial support for clinets and customers，help them solve their capital turnover difficulties，improve the deal efficiency and lower the deal costs .",
  service5: "Comprehensive",
  service6: "Logistics service",
  service7:
    "Aim to provide efficient and convenient logistics support for clinets and customers，help them close a deal well and logistics distribution .",
  service8: "Efficiency",
  service9: "Data service",
  service10:
    "Aim to provide comprehensive，timely and  accurate support for clinets and customers，help them  know the market trends, and make the wiser decisions.",
  service11: "Profession ",
  service12: "To know all about us",
  service13:
    "Including financing services, settlement services and risk management services, the center aims to provide comprehensive financial support for upstream and downstream customers, help them solve the problem of capital turnover, improve transaction efficiency and reduce transaction costs. The center also plans to further expand financial services, including the establishment of a financial product innovation center, to provide more comprehensive and professional financial services for upstream and downstream customers.",
  service14:
    "Including warehousing services, distribution services, customs clearance services, insurance services, aiming to provide efficient and convenient logistics support for upstream and downstream customers, to help them better complete transactions and logistics distribution. The center also plans to further expand logistics services, including the establishment of a logistics information platform and the development of SAAS tools for logistics management, to provide more comprehensive and efficient logistics support for upstream and downstream customers.",
  service15:
    "Including real-time market data, trading data analysis, market information release, and data customization services, it aims to provide upstream and downstream customers with comprehensive, timely and accurate trading data and market information to help them understand market dynamics and trends and make smarter trading decisions. The center also plans to further expand its data services, including the establishment of data centers and the development of data analysis software, so as to provide more comprehensive and professional data support for upstream and downstream customers.",
  slx: "Quantity (box)",
  cdmc: "Name of origin",
  rknf: "Year of warehousing",
  rkyf: "Warehousing month",
  ggzbjdxplace:
    "Please write down the proportion and size of the specifications contained in the goods source, for example, the proportion of 100-150 specifications is 25%, which is too large; Specification 200-3000 accounts for 75%, normal size",
  rules1: "Summary of Rules of Global Seafood  Trading  Platform (Trial)",
  rules2: "Chapter I General Provisions",
  rules3: "Article 1",
  rules4:
    "In order to standardize the online trading rules of the global bulk aquatic products Trading Platform (hereinafter referred to as the Platform), maintain market order and protect the legitimate rights and interests of members, these Detailed Rules are formulated in accordance with relevant laws and regulations such as the Civil Code of the People's Republic of China, the Auction Law of the People's Republic of China, the Service Specifications of the Third-party E-commerce Trading Center, etc.",
  rules5: "Article 2",
  rules6:
    "These rules apply to the trading activities in Global Seafood  Trading  Platform . All the staff, members, market makers, settlement warehouses and related cooperative institutions of the trading Center must abide by these Rules.",
  rules7: "Chapter II Transactions",
  rules8: "Article 3 Opening hours",
  rules9: "1. Monday to Saturday: 9:00-16:30 every day;",
  rules10: "2.The market is closed on Sundays and public holidays",
  rules11: "Article 4 Charging Standard",
  rules12:
    "The buyer and seller shall pay different fees according to different transaction methods and categories. For details, please refer to the Platform Fee Standard.",
  rules13: "role",
  rules14: "Buyer.",
  rules15: "Seller.",
  rules16: "Initiating transaction mode",
  rules17: "Trading rules",
  rules18:
    "The buyer uploads the purchase demand, sets the starting price, and the seller bids according to the buyer's demand. The one with the lowest price wins.",
  rules19:
    "The buyer uploads the purchase demand, sets the price and quantity threshold, and the seller sells according to the buyer's demand.",
  rules20:
    "The seller uploads the goods for sale, sets the starting price, and the buyer bids according to the seller's demand. The highest price wins.",
  rules201:
    "The seller uploads the details of the goods for sale, sets the starting price, and the buyer bids according to the seller's demand. The highest price wins.",
  rules21:
    "The seller uploads the goods details, sets the price, quantity and other thresholds, and the buyer buys according to the seller's goods.",
  rules22: "Central rate",
  rules23: "(interim)",
  rules24:
    "Buyers participating in the transaction will be charged a service fee of 100 yuan/ton",
  rules25: "Participating sellers receive a commission of 5‰",
  rules26: "Deposit",
  rules27:
    "Transaction deposit: The buyer shall first pay 20% of the transaction deposit as the deposit, which will be offset against the payment after the transaction",
  rules28: "Deposit of 100000 yuan for merchants to settle in the center",
  rules29: "Payment and delivery time",
  rules30: "Pay the balance within 24 hours after placing the order",
  rules31: "(If overdue, please contact the center)",
  rules32: "Delivery within 48 hours after full payment from buyer",
  rules33: "Article 5",
  rules34:
    "The quotation currency is RMB, and the quotation unit is: specified according to the requirements of the category.",
  rules35: "Article 6",
  rules36:
    "All users must pay the full deposit before they can participate in selling/buying or registration/bidding as buyers and sellers on the trading platform.",
  rules37: "Article 7 Trading deposit",
  rules38:
    "Buyers and sellers shall pay the corresponding transaction margin according to the requirements of the trading center. After the successful transaction, the margin will be charged against the loan.",
  rules39: "Article 8 Refund of security Deposit",
  rules40:
    "In accordance with the refund conditions, the payment account will be returned to the original path within 2 working days.",
  rules41: "Article 9 Deposit deduction",
  rules42:
    "If any of the following situations are involved in the successful bidding of the goods supply published by the seller, the seller will be penalized with a deposit equal to the transaction amount. If the deposit is insufficient, the full amount paid will be deducted:",
  rules43:
    "1.Delivery source quality is seriously inconsistent with description;",
  rules44:
    "2.The delivery of goods is not completed in accordance with the stipulated time and procedures;",
  rules45:
    "3.Failure to perform the contract according to the published auction price.",
  rules46:
    "4.The Center will deduct the deposit equal to the transaction amount. If the deposit is insufficient, the full amount paid will be deducted.",
  rules47:
    "If the buyer is involved in any of the following circumstances after winning the auction, the buyer will be penalized with a deposit equal to the transaction amount. If the deposit is insufficient, the full amount paid will be deducted:",
  rules48:
    "1.The delivery of goods is not completed in accordance with the stipulated time and procedures;",
  rules49:
    "2.Failure to perform the contract according to the published auction price.",
  rules50:
    "3.The Center will deduct the margin equal to the transaction amount, if the margin is insufficient, the margin will be deducted",
  rules51: "Article 10 The deposit is lost",
  rules52:
    "1.If the auction is successful, but the buyer fails to complete the payment within 1 natural day after the auction ends (payment period of the transaction), and the transaction does not support negotiation to resume the transaction, the deposit paid by the buyer will be forfeited after the end of the payment period of the transaction and paid to the seller as compensation.",
  rules53:
    "2.If the auction is successful, but the buyer fails to complete the payment within 2 natural days after the auction ends (transaction payment period), and the order does not apply for the resumption of the transaction within the negotiated resumption period, the deposit paid by the buyer will be forfeited and paid to the seller after the resumption of the transaction period.",
  rules54:
    "3.If the auction is successful, but the buyer fails to complete the payment in time within 1 natural day after the auction ends (transaction payment period), and the order is applied for recovery within the negotiated transaction recovery period but is not processed by the seller or is refused to resume the transaction, the deposit paid by the buyer will be forfeited and paid to the seller after being refused to resume the transaction.",
  rules55:
    "4.If the seller who has paid the deposit fails to deliver the lot to the buyer as agreed after the transaction, the deposit paid by the seller will be forfeited and compensated to the buyer.",
  rules56: "Article 11 Forfeited deposit minus service fee",
  rules57:
    "1.If the deposit paid by the buyer is forfeited to the seller due to the buyer's breach of contract or violation, the service fee will not be refunded and the buyer has the right to deduct the deposit directly at the time of forfeiting.",
  rules58:
    "2.If the deposit paid by the seller is forfeited to the buyer due to the seller's breach of contract or violation, the corresponding deposit will be deducted according to the actual situation.",
  rules59:
    "3.Special circumstances: If you have any objection to the return or deduction of the margin, you can appeal through the Platform. The Platform, as an intermediary, will coordinate fairly with the buyer and seller to decide whether to return the margin or make the corresponding deduction.",
  rules60: "Article 12",
  rules61:
    "The uploaded information shall include but not be limited to: type, category item specification, tonnage, warehousing time, fishing method, freezing method, fishing area, selling method, source party, photos of source, description of source, etc.",
  rules62:
    "Description of source: Name, weight size, grade, wild/cultured, source form (original strip/cut), specifications, freezing method, packing, weighing point of fixed weight and other supplementary information. ",
  rules621:
    "Order description: category, price, place of shipment, invoice information, etc.",
  rules63: "Article 13 Transaction methods and suggestions on selection",
  rules64: "1.Users can choose to log in the platform bidding and listing.",
  rules65:
    "2.Delay: If there is any bid within 1 minute of the countdown before the end of bidding, the auction will automatically delay 3 minutes on the basis of the bid time, and so on, until no one continues to bid 1 minute before the end of the countdown, the auction will end",
  rules66: "Matters needing attention",
  rules67:
    "Pay attention to set the purchase quantity threshold to prevent malicious bidding. E.g. A ton of goods compete at a low price.",
  rules68: "Understand market price trends to ensure smooth trading.",
  rules69: "Clear source details to ensure the quality of the transaction.",
  rules70: "Clear source details to ensure the quality of the transaction.",
  rules71: "Selection suggestion",
  rules72:
    "The price of the goods has a downward trend. It is recommended to choose the goods if the budget is limited.",
  rules73:
    "Save service fee, control the market price of goods accurately and buy goods for a long time.",
  rules74:
    "The supply of high-quality goods and the market price is stable or has an upward trend, the owner is not clear about the value of the supply and wants to sell at a higher price.",
  rules75:
    "Save service fee, price has clear psychological expectations of adviceChoose.",
  rules76: "Chapter III Settlement in kind",
  rules77: "Article 14",
  rules78:
    "After the successful transaction, the buyer and seller will handle the issue of the target out of the warehouse, equity change and delivery.",
  rules79: "Article 15",
  rules80:
    "Performance agreement: After the transaction, if either of the buyers and sellers breaks the agreement (in line with the situation of margin deduction), in addition to the customer complaint process and margin deduction, the customer will also be included in the customer blacklist of the trading center, which will affect or restrict the participation in subsequent transactions.",
  rules81: "Chapter IV Supplementary Provisions",
  rules82: "Article 16",
  rules83:
    "The right to interpret and revise these Rules shall be reserved by Global Seafood  Trading  Platform.",
  rules84: "Article 17",
  rules85:
    "The global bulk aquatic products trading platform has the right to revise and adjust the margin rules according to the needs of the trading platform, and users will be notified of the revised rules through the website letter, website publicity and other appropriate means. If users continue to use the Trading Platform and pay the margin after the margin rules are amended, Users shall be deemed to have fully understood and accepted the revised margin rules and agree that the Trading Platform shall manage the margin paid by Users in accordance with the revised rules.",
  rules86: "Article 18",
  rules87:
    "Any dispute arising out of these Rules shall be settled by the parties through friendly negotiation. If no settlement can be reached through negotiation, the parties agree to submit the matter in dispute to the relevant arbitration department for arbitration in accordance with the arbitration rules in effect at the time of applying for arbitration. The arbitral award shall be final and binding upon all parties.",
  rules88: "Article 19",
  rules89:
    "The interpretation and implementation of these Rules shall be governed by the laws of Mainland China, and the determination of any provision of these Rules as invalid shall not affect the validity of the other provisions.",
  rules90: "Article 20",
  rules91: "These rules shall take effect as of the date of promulgation.",
  contact1: "The phone number is 400-101-2799",
  contact2: "Email: mail@huacaizhaoyu.com",
  contact3:
    "Address: Room 601A, Building E1, Huateng Century Headquarters Park, Chenjialin Yard 9, Balizhuang, Chaoyang District, Beijing",
  contact4: "sweep",
  contact5: "View Mini apps",
  contact6: "Pay attention to",
  contact7: "WeChat official account",
  indexnew1:
    "Build a global online trading platform for high-end aquatic products",
  indexnew2:
    "Approved by Shenzhen Municipal Government, it is jointly initiated by China Agricultural Development Group and Shenzhen Port Group, with technical support from Beijing Huacai. As Shenzhen national oceangoing fishery base pilot project put into operation.",
  indexnew3: "Standardized rating pricing system",
  indexnew4: "Professional quality control team",
  indexnew5: "AI technology",
  indexnew6: "Trace the source",
  indexnew7: "Delivery system",
  indexnew8: "Delivery warehouse network",
  indexnew9: "Credit system",
  indexnew10: "Customer rating",
  indexnew11: "Platform guarantee",
  delivery1: "Global Seafood  Trading  Platform global delivery warehouse",
  delivery2:
    "To provide global delivery services for tuna in the trading center",
  delivery3:
    "The global delivery warehouse includes the delivery warehouse owned by the trading center and the delivery warehouse jointly built with domestic and foreign partners, covering the major cities and ports in the major production and consumption areas of tuna.",
  delivery4:
    "Internationalization, standardization, specialization and branding",
  delivery5:
    "The construction and development of the global delivery warehouse will provide more convenient, efficient, safe and reliable delivery services for the tuna in the trading center, and expand the international influence and popularity of the trading center.",
  delivery6: "Strengthen cooperation with domestic and foreign partners",
  delivery7:
    "The trading center will continue to strengthen cooperation with domestic and foreign partners and expand the network and coverage of the global delivery warehouse.",
  delivery8: "Covering major coastal distribution centers",
  delivery9:
    "Covering major coastal distribution centers in China: Dalian, Qingdao, Zhoushan, Fuzhou, Shenzhen, Kaohsiung, etc. Covering China and East Asia: Tokyo, Busan, Bangkok, etc.",
  delivery10:
    "Shenzhen International Tuna Exchange Center Global Delivery warehouse refers to the global delivery warehouse network established by the exchange Center, aiming at providing global delivery services for the tuna in the Exchange Center. The global delivery warehouse includes the delivery warehouse owned by the trading center and the delivery warehouse jointly built with domestic and foreign partners, covering the major cities and ports in the major production and consumption areas of tuna.",
  delivery11:
    "The construction and development of global delivery warehouse is an important part of the development strategy of internationalization, standardization, specialization and brand of the trading center. The construction and development of the global delivery warehouse can provide more convenient, efficient, safe and reliable delivery services for the tuna in the trading center, and expand the international influence and popularity of the trading center.",
  delivery12:
    "At present, the trading center has established cooperative relations with many leading enterprises and institutions in the main coastal cities in China. In the future, the trading Center will continue to strengthen cooperation with domestic and foreign partners, expand the network and coverage of the global delivery warehouse, improve the quality and efficiency of delivery services, and provide customers with more high-quality services and more convenient delivery methods.",
  delivery13:
    "Stage construction and development plan of delivery warehouse network:",
  delivery14:
    "The first stage: covering major coastal distribution centers in China: Dalian, Qingdao, Zhoushan, Fuzhou, Shenzhen, Kaohsiung, etc.",
  delivery15:
    "The second stage: covering China and East Asia: Tokyo, Busan, Bangkok, etc.",
  delivery16:
    "The third stage: covering major distribution centers of the Belt and Road countries.",
  rksj: "Warehousing time",
  szjg: "Shenzhen price",
  nian: "Year",
  yue: "Month",
  zajzzz: "loading",
  flllll: "Classification",
  xia: "Argentine red shrimp",
  xue: "Cod",
  zhgll: "Account association",
  ztzh1: "Principal account",
  dqdlzh1: "(Current login account)",
  yglfh1: "A secondary number has been associated",
  xz1: "New",
  bzmc1: "Remarks name",
  cz1: "Controls",
  tjxgbz: "Add or modify remarks",
  dqzhybgl: "The current account has been associated",
  ryywqlx: "If you have any questions, please contact",

  glzh1: "Associated account",
  qsrxygldsjh: "Please enter the phone number to be associated",
  qsrbz1: "Please enter remarks (less than 8 words)",
  dqgldsjh1: "Current associated mobile phone number",
  glcg: "Association success",
  cczjyjscsfjx:
    "This operation will be permanently deleted. Do you want to continue?",
  tss1: "Tips"
};



// WEBPACK FOOTER //
// ./src/lang/en.js